export default "__VITE_ASSET__51a80796__"